module.exports = __webpack_public_path__ + "static/chirpyest-logo-2fb0d4e48cb0f12c2ecdcf3d8fb17823.svg";